import React, { FC, memo } from "react";
import Svg from "./Svg";
import colors from "../../utils/colorConstants";

interface Props {
  className?: string;
  height?: string;
  strokeColor?: string;
  width?: string;
}

const NoAds: FC<Props> = ({
  className,
  height = "1.5rem",
  strokeColor = colors.lapel,
  width = "1.5rem",
}) => (
  <Svg
    className={className}
    height={height}
    viewBox="0 0 24 24"
    width={width}
    title="no ads icon"
  >
    <path
      fill={strokeColor}
      fillRule="evenodd"
      d="M18 2a2 2 0 011.72 1c.17.3.28.63.28 1v9.76A4.5 4.5 0 1113.26 19H5a2 2 0 01-2-2V4c0-.37.1-.7.28-1A2 2 0 015 2zm-4 15.5a3.5 3.5 0 005.6 2.8l-4.89-4.92A3.48 3.48 0 0014 17.5zm3.5-3.5c-.78 0-1.5.25-2.07.68l4.87 4.92a3.5 3.5 0 00-2.8-5.6zM4 7v10a1 1 0 001 1h8l.03.03A4.5 4.5 0 0119 13.25V7H4zm14 1v3H5V8h13zm-1 1H6v1h11V9zm-3.5-5a.5.5 0 110 1 .5.5 0 010-1zm2 0a.5.5 0 110 1 .5.5 0 010-1zm2 0a.5.5 0 110 1 .5.5 0 010-1zM4 6h15V4a1 1 0 00-1-1H5a1 1 0 00-1 1v2z"
    />
  </Svg>
);

export default memo(NoAds);
